import { audiencesContract } from '@mntn/api-contracts/flight-deck/v1/audiences'
import type { ClientInferResponseBody } from '@ts-rest/core'
import { useFlightDeckTsRestClient } from '@/flight-deck-api/ts-rest'
import { useAuthenticatedSession } from '@/providers/session'

export type AudienceCompare = ClientInferResponseBody<typeof audiencesContract.compare, 200>['data']

export const useAudiencesService = () => {
  const audiencesClient = useFlightDeckTsRestClient(audiencesContract)
  const { session } = useAuthenticatedSession()

  return {
    getAudienceComparison: {
      handler: async ({ audienceId, campaignGroupId }: { audienceId: number; campaignGroupId: number }) => {
        const response = await audiencesClient.compare({
          query: {
            'advertiser-id': session.advertiser.id,
            'audience-id': audienceId,
            'campaign-group-id': campaignGroupId,
          },
        })

        if (response.status !== 200) {
          throw new Error(`Failed to fetch audience comparison: ${response.status}`)
        }

        return response.body.data
      },
    },
  }
}
